<template>
    <div class="input-wrapper" :class="[{ 'error':this.error }, {'display':this.display}]">
        <textarea :id="computedId" autocomplete="off" :min="min" @click="clicked" :class="{ 'edited' : edited }" :style="backgroundColor ? 'background-color: ' + backgroundColor + ' !important;' : ''" :type="type" :value="modelValue" @input="handleInput($event.target.value)" :placeholder="placeholder" :disabled="disabled" :readonly="display"/>

        <label :for="inputId" class="input-label" v-if="label" :style="backgroundColor ? 'background-color: ' + backgroundColor + ' !important;' : ''">{{ this.label }} {{ required ? '*' : '' }}</label>

        <div class="error-container">
            <label class="error-label" :class="{ 'show' : error }">{{ this.errorText }}</label>
        </div>
    </div>
</template>

<script>
export default {
    name: 'textarea-input',
    props: {
        modelValue: {
            type: [Number, String]
        },
        type: {
            type: String,
            default: 'text'
        },
        placeholder: {
            type: String,
            default: ' ' // is used to trigger the floating label so it can not be empty
        },
        edited: {
            type: Boolean,
            default: false
        },
        display: Boolean,
        disabled: Boolean,
        label: String,
        required: Boolean,
        error: Boolean,
        errorText: String,
        backgroundColor: String,
        min: Number,
        inputId: String,
        idStub: String
    },
    methods: {
        handleInput: function(value) {
            this.$emit('update:modelValue', value)
        },
        clicked: function(event) {
            this.$emit('click', event)
        }
    },
    computed: {
        computedId: function() {
            const externalId = this.inputId || ''
            const stub = this.idStub ? '-' + this.idStub : ''
            return `input-${externalId}${stub}`
        }
    }
}
</script>

<style scoped>
.input-wrapper {
    position: relative;
}

.input-wrapper {
    padding-top: 15px;
}

.input-wrapper > .input-label {
    color: #064A6C;
    position: absolute;
    font-size: 1em;
    left: 10px;
    background: #fff;
    top: 7px;
    padding: 0px 5px;
    transition: .1s all;
    height: 10px;
    line-height: 10px;
}

.input-wrapper.display > input {
    border-color:#ccc;
}

/* https://zellwk.com/blog/check-empty-input-css/ */
textarea:not(:placeholder-shown):not(:read-only) + .input-label,
textarea:focus:not(:read-only) + .input-label {
    top: 0px;
    left: 0px;
}

textarea {
    width: 100%;
    min-height: 80px;
    max-height: 200px;
    resize: vertical;
    box-sizing: border-box;
    font-size: 1.2em;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    background-color: #fff;
    border-radius: var(--input-border-radius);
    padding-left: 10px;
    border: 1px solid #064A6C;
}

textarea::placeholder {
    font-size: 1em;
}

textarea:disabled {
    border-color: #ddd;
    cursor: not-allowed;
}

textarea.edited {
    border-color: green;
    border-width: 2px;
}

.textinput-container > label {
    color: #fff;
}

.input-label {
    font-size: 1.1em;
    color: #2c2e2f;
}

.error-container {
    min-height: 15px;
    margin-top: 3px;
    padding-left: 10px;
    color: red;
    text-align: left;
}

.error-container > .error-label {
    visibility: hidden;
}

.error-container > .error-label.show {
    visibility: visible;
}

.input-wrapper.error :deep(*) {
    color: red;
}

.input-wrapper.error > input {
    border: 1px solid red;
}
</style>